import get from 'lodash/get';
import {useState} from 'react';
import _ from "lodash";

import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import SvgIcon from "@mui/material/SvgIcon";

import {formatLastSeen, formatPatientName} from '../../helpers/patients';
import CustomCard from '../common/CustomCard';
import EditPatientMemoDialog from './EditPatientMemoDialog';
import EditPatientStatus from './EditPatientStatus';
import MessageUserButton from '../messages/MessageUserButton';
import SchedulePatientButton from './SchedulePatientButton';
import ViewPatientButton from './ViewPatientButton';
import {getPatientStatusOptions} from "./PatientStatusFilter";
import {CalendarIcon, DescriptionIcon, EditIcon, LaunchIcon, PersonIcon, PlaceholderIcon} from "../../styles/icons";
import EditPatientLeadDialog from "./EditPatientLeadDialog";

const getButtons = ({patient}) => ([
  <SchedulePatientButton patient={patient} variant='outlined' fullWidth color='primary' textOnly={true}/>,
  <MessageUserButton patient={patient} variant='outlined' fullWidth color='primary' textOnly={true}/>,
]);

const PatientCard = props => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const {patient: p} = props;
  if (!p) {
    return <></>;
  }

  const {Icon, color} = getPatientStatusOptions(_.camelCase(get(p, 'patient_status.status')));

  return (
    <Box key={p.id}>
      <CustomCard listItems={[
        {
          Icon: (() => <SvgIcon component={PersonIcon} style={{color: 'var(--text)', fontSize: '1.25rem'}} inheritViewBox/>),
          text: (
            <Grid container alignItems='center' justifyItems='center' spacing={0}>
              <Grid item xs={9} paddingRight="0.5rem">
                <Typography className="card-title text-ellipsis">
                  {formatPatientName(p)}
                </Typography>
              </Grid>
              <Grid item xs={3} display="flex" alignItems='center' justifyContent="end">
                {/* <Icon style={{color, fontSize: '1.5rem', marginRight: '18px'}}/> */}
                <ViewPatientButton iconOnly patient={p} Icon={() => <SvgIcon component={LaunchIcon} style={{color: '#000', fontSize: '1.5rem', opacity: 0.54}} inheritViewBox/>}/>
              </Grid>
            </Grid>
          ),
          key: 'name',
        },
        {
          Icon: null,
          noIcon: true,
          key: 'status',
          text: (
            <Grid container alignItems='center' justifyItems='center' spacing={0}>
              <EditPatientStatus patient={p} />
            </Grid>
          ),
        },
        {
          Icon: (() => <SvgIcon component={CalendarIcon} style={{color: 'var(--text)', fontSize: '1.25rem'}} inheritViewBox/>),
          text: (
            <Grid container alignItems='center' justifyItems='center'>
              <Grid item xs={9} paddingRight="0.5rem">
                <Typography sx={{fontSize: '14px', fontWeight: 600}} className="text-ellipsis">Last seen:&nbsp;
                  <span style={{color: 'var(--light-text)'}}>{formatLastSeen(p)}</span>
                </Typography>
              </Grid>
            </Grid>
          ),
          key: 'lastSeen',
        },
        {
          Icon: (() => <SvgIcon component={PlaceholderIcon} style={{color: 'var(--text)', fontSize: '1.25rem'}} inheritViewBox/>),
          text: (
            <Grid container alignItems='center' justifyItems='center'>
              <Grid item xs={9} paddingRight="0.5rem">
                {dialogOpen === 'referralDetails' && <EditPatientLeadDialog patient={p} isOpen={!!dialogOpen} onClose={() => setDialogOpen(false)} onSuccess={() => props.reload()}/>}
                <Typography sx={{fontSize: '11px', fontWeight: 600}} className="text-ellipsis">Referral source:&nbsp;
                  <span style={{color: 'var(--light-text)'}}>{p.referral_details || '-'}</span>
                </Typography>
              </Grid>
              <Grid item xs={3} display="flex" alignItems='center' justifyContent='end'>
                <IconButton color='primary' variant='outlined' onClick={() => setDialogOpen('referralDetails')} sx={{padding: 0, marginRight: '42px'}}>
                  <EditIcon style={{fontSize: '1.2rem'}} fill={'var(--primary)'}/>
                </IconButton>
              </Grid>
            </Grid>
          ),
          key: 'referral_details',
        },
        {
          Icon: (() => <SvgIcon component={DescriptionIcon} style={{color: 'var(--text)', fontSize: '1.25rem'}} inheritViewBox/>),
          text: (
            <Grid container alignItems='center' justifyItems='center'>
              <Grid item xs={9} paddingRight="0.5rem">
                {dialogOpen === 'note' && <EditPatientMemoDialog isOpen={!!dialogOpen} patient={p} onClose={() => setDialogOpen(false)} onSuccess={() => props.reload()}/>}
                <Typography sx={{fontSize: '11px', fontWeight: 600}} className="text-ellipsis">Note:&nbsp;
                  <span style={{color: 'var(--light-text)'}}>{get(p, 'patient_status.note') || '-'}</span>
                </Typography>
              </Grid>
              <Grid item xs={3} display="flex" alignItems='center' justifyContent='end'>
                <IconButton color='primary' onClick={() => setDialogOpen('note')} sx={{padding: 0, marginRight: '42px'}}>
                  <EditIcon style={{fontSize: '1.2rem'}} fill={'var(--primary)'}/>
                </IconButton>
              </Grid>
            </Grid>
          ),
          key: 'note',
        },
      ]} noTopBorder buttons={getButtons({patient: p})} passButtonChildren={true}/>
    </Box>
  );
};

export default PatientCard;
